/** InsCoder WANG.J 2025-08-30 B + Collection tab switching functionality **/

document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.section-collection-tab__tab');
  const productGrids = document.querySelectorAll('.section-collection-tab__product-grid');
  const heroImage = document.getElementById('hero-image');
  const collectionButton = document.getElementById('collection-button');
  const button = document.getElementById("collection-button");

  if (tabs.length === 0) return;

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', function() {
      const tabIndex = parseInt(this.getAttribute('data-tab'));
      
      // Remove active class from all tabs
      tabs.forEach(t => t.classList.remove('active'));
      
      // Add active class to clicked tab
      this.classList.add('active');

      const handle = this.getAttribute("data-collection-handle");

      // Update button href
      if (handle) {
        button.setAttribute("href", "/collections/" + handle);
      }
      
      // Hide all product grids
      productGrids.forEach(grid => grid.classList.remove('active'));
      
      // Show corresponding product grid
      const targetGrid = document.querySelector(`[data-tab-content="${tabIndex}"]`);
      if (targetGrid) {
        targetGrid.classList.add('active');
      }
      
      // Update hero image if data is available
      const newImageSrc = this.getAttribute('data-main-image');
      if (newImageSrc && newImageSrc !== 'null' && heroImage) {
        heroImage.src = newImageSrc;
      }
      
      // Update button text and link
      const buttonText = this.getAttribute('data-button-text');
      if (buttonText && buttonText !== 'null' && collectionButton) {
        collectionButton.textContent = buttonText;
        
        // Try to get collection handle from the corresponding block
        const targetProductGrid = document.querySelector(`[data-tab-content="${tabIndex}"]`);
        if (targetProductGrid) {
          const firstProductLink = targetProductGrid.querySelector('.section-collection-tab__product-link');
          if (firstProductLink) {
            const productUrl = firstProductLink.getAttribute('href');
            if (productUrl) {
              // Extract collection from product URL if possible
              const collectionMatch = productUrl.match(/\/collections\/([^\/]+)/);
              if (collectionMatch) {
                collectionButton.href = `/collections/${collectionMatch[1]}`;
              }
            }
          }
        }
      }
    });
  });
});

/** InsCoder WANG.J 2025-08-30 E + Collection tab switching functionality **/
